import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addOnBoard,
  deleteOnBoard,
  fetchOnBoard,
  moveOnBoard,
  updateOnBoard,
} from "../../apis/onBoard";

import type { onBoardPayload } from "../../utils/types/onBoard";

export const fetchOnBoardData = createAsyncThunk(
  "onBoard/fetchOnBoardServices",
  async (
    { berthId, jobId }: { berthId?: string; jobId?: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await fetchOnBoard(berthId, jobId);
      return {
        data: response,
        jobId,
      };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
);

export const updateOnBoardData = createAsyncThunk(
  "onBoard/updateOnBoardServices",
  async (
    {
      id,
      berthId,
      jobId,
      data,
    }: {
      id: string;
      berthId?: string;
      jobId?: string;
      data: { [key: string]: any; onBoardServiceId: string };
    },
    { rejectWithValue }
  ) => {
    try {
      await updateOnBoard(id, berthId, jobId, data);
      return {
        success: true,
        data,
        onBoardServiceId: data.onBoardServiceId,
        berthId,
        jobId,
      };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
);

export const deleteOnBoardData = createAsyncThunk(
  "onBoard/deleteOnBoardServices",
  async (
    { id, berthId, jobId }: { id: string; berthId: string; jobId: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await deleteOnBoard({ id, berthId });
      if (response.success) {
        return { onBoardServiceId: id, jobId, success: true };
      }
      return rejectWithValue("Unknown error… Please try again");
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
);

export const addOnBoardData = createAsyncThunk(
  "onBoard/addOnBoardServices",
  async ({ data }: { data: onBoardPayload }, { rejectWithValue }) => {
    try {
      const response = await addOnBoard(data);
      return {
        data: response,
        jobId: data.jobId,
      };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
);

export const moveOnBoardData = createAsyncThunk(
  "cargo/moveOnBoard",
  async (
    {
      id,
      berthId,
      jobId,
    }: {
      id: string;
      berthId: string;
      jobId: string;
    },
    { rejectWithValue }
  ) => {
    try {
      await moveOnBoard(id, berthId);
      return {
        success: true,
        id,
        data: {
          onBoardServiceId: id,
          berthId,
        },
        jobId,
      };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
);
